import React, { Component } from 'react';
import Matrix from './Matrix';
import { getGroupColors } from 'lib/helper';


export default class AdjacentMatrixViewInternal extends Component {

  constructor(props) {
    super(props);
    this.matrixRef = React.createRef();
    this.editCellModelRef = React.createRef();
    this.colorOptions = {};
    const c = getGroupColors();
    props.data.result.nodes.forEach(({ group }) => {
      this.colorOptions[group] = '#' + c(group);
    });
  }

  showEditModal = (row, col, links) => {
    this.editCellModelRef.current.showModal(row, col, links);
  };

  componentDidMount() {
    if (this.setNodes)
      this.setNodes(this.matrixRef.current.totalNodes);
  }

  editCellConfirm = () => {
    this.props.saveMatrixLocal(this.props.data.result);
  };

  render() {
    return (
      <React.Fragment>
        <Matrix
          ref={this.matrixRef}
          {...this.props}
          showEditModal={this.showEditModal}
          colorOptions={this.props.colorOptions || this.colorOptions}
          notCollapse={this.props.notCollapse}
          width={this.props.width}
          height={this.props.height}
          choosen={this.props.choosen}
        />
      </React.Fragment>
    );
  }
}

